// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1NMLz","title":"InfoRow_title__3zKGp"};